import PillTray from "./PillTray";

export default PillTray;
